import React, { Fragment } from "react";
import { connect } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { withStyles } from "@material-ui/core/styles";

import _ from "lodash";

import SelectMetricsStep from "./SelectMetricsStep";
import OrderMetricsStep from "./OrderMetricsStep";
import { updateContactScreenPreferences } from "../../../shared-utility/store/state/screenPreferences";

const StepperWrapper = styled.div`
  width: 400px;
  margin: 0 auto;
`;
const StyledTitle = styled.div`
  //styleName: Work Sans / 24;
  font-family: Work Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  padding-left: 20px;
  padding-top: 20px;
 `;
const styles = {
  active: {
    color: "#2196f3 !important"
  },
  completed: {
    color: "#2196f3 !important"
  }
};

class PrefDialog extends React.Component {
  state = {
    activeStep: 0,
    preferences: []
  };

  get maxCount() {
    return this.props.maxCount || 6;
  }

  componentDidMount() {
    this.resetPreferences();
  }

  componentDidUpdate(prevProps, prevState) {
    const isPrefDataSame = this.props.prefData === prevProps.prefData;
    if (!_.isEmpty(this.props.prefData)) {
      this.resetPreferences(!isPrefDataSame);
    }
  }

  updatePreferences = newPreferences => {
    this.setState({ preferences: newPreferences });
  };

  resetPreferences = override => {
    const { prefData } = this.props;
    const { preferences } = this.state;

    if (_.isEmpty(preferences) || override) {
      const newPreferences = _.cloneDeep(prefData);
      this.updatePreferences(newPreferences);
    }
  };

  onToggle = elementId => {
    if (
      this.isElementSelected(elementId) ||
      this.getSelectedCount() < this.maxCount
    ) {
      const newPreferences = _.cloneDeep(this.state.preferences);
      let index = newPreferences.findIndex(
        x => x.screenElementId === elementId
      );
      newPreferences[index].isSelected = !newPreferences[index].isSelected;
      this.updatePreferences(newPreferences);
    }
  };

  isElementSelected = elementId => {
    const { preferences } = this.state;
    let index = preferences.findIndex(x => x.screenElementId === elementId);
    return preferences[index].isSelected;
  };

  getSelectedCount = () => {
    return this.state.preferences.filter(x => x.isSelected).length;
  };

  prevStep = step => () => {
    this.setState({
      activeStep: step - 1
    });
  };

  goToOrderStep = (step, preferences) => {
    this.setState({
      activeStep: step + 1
    });
  };

  closeModal = () => {
    this.props.onClose();
    this.setState({ activeStep: 0, preferences: [], isOpen: false });
  };

  save = () => {
    const { preferences } = this.state;
    let contactScreenPreferences = {
      screenType: this.props.screenType,
      preferences: preferences.filter(x => x.isSelected)
    };

    if(this.props.updateContactScreenPreferencesCallback){
      contactScreenPreferences.callback = this.props.updateContactScreenPreferencesCallback;
    }

    this.props.updateContactScreenPreferences(contactScreenPreferences);
    this.closeModal();
  };

  renderStepContent = activeStep => {
    const { preferences } = this.state;
    switch (activeStep) {
      case 0:
        return (
          <SelectMetricsStep
            isMetric={this.props.isMetric}
            metrics={preferences}
            onToggle={this.onToggle}
            activeStep={activeStep}
            handleClose={this.closeModal}
            maxCount={this.maxCount}
            handleNext={this.goToOrderStep}
          />
        );
      case 1:
        return (
          <OrderMetricsStep
            isMetric={this.props.isMetric}
            metrics={preferences}
            activeStep={activeStep}
            updateMetrics={this.updatePreferences}
            handleClose={this.closeModal}
            handleBack={this.prevStep}
            handleSave={this.save}
          />
        );
      default:
        return null;
    }
  };

  render() {
    let { isOpen, classes } = this.props;
    let { activeStep } = this.state;
    const stepIconProps = {
      classes: {
        active: classes.active,
        completed: classes.completed
      }
    };
    return (
      <Fragment>
        <Dialog open={isOpen} onClose={this.closeModal} fullWidth maxWidth="md" id="customizePreferencesModel">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <StyledTitle>Customize Preferences</StyledTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.closeModal} id="exitCustomizePreferences">
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>
          <StepperWrapper>
            <Stepper activeStep={activeStep} alternativeLabel>
              <Step key="select_metrics">
                <StepLabel StepIconProps={stepIconProps}>
                  Select Items
                </StepLabel>
              </Step>
              <Step key="order_metrics">
                <StepLabel StepIconProps={stepIconProps}>
                  Set Item Order
                </StepLabel>
              </Step>
            </Stepper>
          </StepperWrapper>
          {this.renderStepContent(activeStep)}
        </Dialog>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    screen_pref: state.screenPreferences.screen_pref || null
  };
}

export default connect(
  mapStateToProps,
  { updateContactScreenPreferences }
)(withStyles(styles)(PrefDialog));
